import actions from './actions';
import getters from './getters';
import { MetricsState } from './types/index';

export { namespace } from './types/index';

export const state: MetricsState = {
  errorMessage: ''
};

const namespaced = true;

export const module = {
  namespaced,
  state,
  actions,
  getters
};
